<ng-container
  *ngIf="
    currentUrl === '/confirm-password' ||
      currentUrl === '/generate-new-password' ||
      currentUrl === '/validate-user' 
    else lead
  "
>
  <router-outlet></router-outlet>
</ng-container>

<ng-template #lead>
  <div class="content-main smooth-animation" [class]="toggled">
    <app-header [(toggled)]="toggled"></app-header>
    <div class="sidebar">
      <app-sidebar></app-sidebar>
    </div>
    <div class="content-area">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
  </div>
</ng-template>
